import { render, staticRenderFns } from "./MiniWizardStickyCredits.vue?vue&type=template&id=347f3a4f&"
import script from "./MiniWizardStickyCredits.vue?vue&type=script&lang=js&"
export * from "./MiniWizardStickyCredits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports